import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=5c4cb1ce&scoped=true&"
import script from "./credits.vue?vue&type=script&lang=js&"
export * from "./credits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cb1ce",
  null
  
)

export default component.exports